import React, { useCallback } from 'react';
import { View, TouchableOpacity } from 'react-native';
import { Image } from 'expo-image';
import Ionicons from '@expo/vector-icons/Ionicons';
import { Text } from '../../../components/ui/AppText';
import { styles } from './styles';

const formatDuration = (s) => {
  if (s == null) return null;
  const m = Math.floor(s / 60);
  const sec = s % 60;
  return `${m}:${String(sec).padStart(2, '0')}`;
};

/**
 * Card enxuto de vídeo para a aba "Posts" do perfil. Toque reproduz (player reel
 * reutilizado); apagar só para o dono. Não depende de `author` (sem JOIN no fetch).
 */
const ProfileVideoCard = ({ video, colors, isOwner, onDelete, onPress }) => {
  const handleDelete = useCallback(() => onDelete?.(video), [onDelete, video]);
  const duration = formatDuration(video.durationSeconds);

  return (
    <View style={[styles.videoCard, { backgroundColor: colors?.bgCard || '#1A1D26' }]}>
      <TouchableOpacity
        style={styles.videoThumbWrap}
        activeOpacity={0.85}
        onPress={() => onPress?.(video)}
      >
        {video.thumbnailUrl ? (
          <Image source={{ uri: video.thumbnailUrl }} style={styles.videoThumb} contentFit="cover" transition={150} />
        ) : (
          <View style={[styles.videoThumb, styles.thumbPlaceholder]}>
            <Text style={styles.thumbPlaceholderIcon}>▶</Text>
          </View>
        )}
        {duration ? (
          <View style={styles.durationPill}>
            <Text style={styles.durationText}>{duration}</Text>
          </View>
        ) : null}
      </TouchableOpacity>

      <View style={styles.videoInfo}>
        <Text style={[styles.videoTitle, { color: colors?.textPrimary || '#FFFFFF' }]} numberOfLines={2}>
          {video.title}
        </Text>
        <Text style={[styles.videoMeta, { color: colors?.textTertiary || '#6B6E7B' }]} numberOfLines={1}>
          {video.viewsCount ?? 0} views · {video.section === 'relevant' ? 'Relevantes' : 'Atualizações'}
        </Text>
      </View>

      {isOwner && (
        <TouchableOpacity
          style={styles.videoDeleteBtn}
          onPress={handleDelete}
          hitSlop={10}
          accessibilityRole="button"
          accessibilityLabel="Apagar vídeo"
        >
          <Ionicons name="trash-outline" size={18} color="#FF6B6B" />
        </TouchableOpacity>
      )}
    </View>
  );
};

export default React.memo(ProfileVideoCard);
